import type { Staff, StaffHoursConfig } from "@/types/staff/api-types/staff-types";

export type StaffFormValues = {
  level_id: number;
  first_name: string;
  last_name: string;
  preferred_name: string;
  pronouns: string;
  phone: string;
  email: string;
  address: string;
  emergency_contact_name: string;
  emergency_contact_phone: string;
  start_date: Date | null;
  end_date: Date | null;
  birthday: Date | null;
  hours: StaffHoursConfig[];
  services: number[];
};

const getDefaultHours = (): StaffHoursConfig[] =>
  [1, 2, 3, 4, 5, 6, 7].map((day) => ({
    day_of_week: day,
    start_time: "09:00",
    end_time: "17:00",
    is_active: day <= 5,
  }));

export const getStaffFormValues = (staff?: Staff): StaffFormValues => {
  if (!staff) {
    return {
      level_id: 0,
      first_name: "",
      last_name: "",
      preferred_name: "",
      pronouns: "",
      phone: "",
      email: "",
      address: "",
      emergency_contact_name: "",
      emergency_contact_phone: "",
      start_date: null,
      end_date: null,
      birthday: null,
      hours: getDefaultHours(),
      services: [],
    };
  }

  return {
    level_id: staff.level_id,
    first_name: staff.first_name,
    last_name: staff.last_name,
    preferred_name: staff.preferred_name ?? "",
    pronouns: staff.pronouns ?? "",
    phone: staff.phone ?? "",
    email: staff.email,
    address: staff.address ?? "",
    emergency_contact_name: staff.emergency_contact_name ?? "",
    emergency_contact_phone: staff.emergency_contact_phone ?? "",
    start_date: staff.start_date,
    end_date: staff.end_date ?? null,
    birthday: staff.birthday ?? null,
    hours: (staff.hours ?? []).map(
      ({ day_of_week, start_time, end_time, is_active }): StaffHoursConfig => ({
        day_of_week,
        start_time,
        end_time,
        is_active,
      })
    ),
    services: (staff.services ?? []).map((s) => s.service_id),
  };
};
